module.exports = __webpack_public_path__ + "img/antes_despues_15.1ac4d0f5.png";